/**
 * App Config File
 */
export default {
    appLogo: '/static/img/wylogo.png', // App Logo,
    darkLogo: '/static/img/wylogo.png', // dark logo
    appLogo2: '/static/img/wylogo.png', // App Logo 2 For Login & Signup Page
    brand: '', // Brand Name
    copyrightText: '', // Copyright Text
    enableUserTour: process.env.NODE_ENV === 'production' // Enable User Tour
}
